import Vue from 'vue'
import Router from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import ServicesView from '@/views/ServicesView.vue'
import ContactView from '@/views/ContactView.vue'
import bulletin from '@/views/bulletin-board.vue'
import blog from '@/views/xiangqing.vue'
import FaqView from '@/views/FaqView.vue'
import documentpost from '@/views/tiezi.vue'


Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView
  },
  {
    path: '/services',
    name: 'Services',
    component: ServicesView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
   {
    path: '/bulletin-board',
    name: 'bulletin-board',
    component: bulletin
  },
   {
    path: '/blog',
    name: 'blog',
    component: blog
  },
  {
    path: '/documentpost',
    name: 'documentpost',
    component: documentpost
  },
  {
    path: '/faq',
    name: 'Faq',
    component: FaqView
  }
]

const router = new Router({
  mode: 'hash',
  routes
})

// 页面标题映射
const titles = {
  Home: '首页',
  About: '关于',
  Services: '服务',
  Contact: '联系',
  'bulletin-board': '博客',
  blog: '详情',
  documentpost: '帖子',
  Faq: '常见问题'
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  const label = titles[to.name] || ''
  document.title = label ? `${label}-19.9` : '19.9'
  console.log(to.fullPath)
  localStorage.setItem('currentPath', to.fullPath)
  next()
})

export default router
